import { Outlet } from 'react-router';
import SideNav from './SideNav';
import { useLocation } from 'react-router-dom';
import WhyRegister from './WhyRegister';
import useMobileView from '../common/hooks/useMobileView';
import * as Sentry from '@sentry/react';

const MainContent = () => {
	const location = useLocation();
	const [isDisplaySideNav] = useMobileView();

	Sentry.startInactiveSpan({ name: 'Main Content' });

	return (
		<main className="content-container my-account-dashboard" id="main-content">
			<section className="vce-db-container">
				<div className="container">
					<div className="dashboardnav-cnt">
						{isDisplaySideNav && <SideNav />}
						<section className="vce-db-main">
							<Outlet />
						</section>

						{!isDisplaySideNav && <SideNav />}
					</div>
				</div>
			</section>

			{/* Why register component */}

			{location.pathname === '/devices' && <WhyRegister />}
		</main>
	);
};

export default MainContent;
